import { createContext } from 'react';
const createModuleProvider = () => {
  const moduleRefs = {};
  const updateModuleRef = (moduleName, moduleInfo) => {
    moduleRefs[moduleName] = Object.assign({}, moduleInfo);
  };
  const getModuleRefs = () => moduleRefs;
  return {
    getModuleRefs,
    updateModuleRef
  };
};
const InpageModuleContext = /*#__PURE__*/createContext(createModuleProvider());
export default InpageModuleContext;